import {ExclamationCircleIcon, EyeIcon, EyeSlashIcon} from "@heroicons/react/24/outline";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {getErrorMessageHtml, getInputErrorClasses, hasFieldAnError} from "../../Utils/FormHelpers";

export const PasswordInput = (props) => {
    const {
        register,
        name,
        translationIndex,
        errors,
    } = props;
    const {t} = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const hasError = hasFieldAnError(errors, name);

    return (
        <div>
            <label htmlFor={name}
                   className="block text-left text-sm font-medium leading-6 text-gray-900">
                {t(`${translationIndex}`)}
            </label>
            <div className="relative mt-2 rounded-md shadow-sm">
                <input
                    {...register(name)}
                    id={name}
                    name={name}
                    type={showPassword ? "text" : "password"}
                    autoComplete={name}
                    className={`block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${getInputErrorClasses(errors, name)}`}
                />

                <div className="absolute inset-y-0 right-0 flex items-center gap-2 pr-3">
                    {hasError && (
                        <ExclamationCircleIcon
                            className="pointer-events-none h-5 w-5 text-red-500"
                            aria-hidden="true"/>
                    )}
                    <button
                        type="button"
                        tabIndex={-1}
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? "Wachtwoord verbergen" : "Wachtwoord tonen"}
                        className="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none">
                        {showPassword
                            ? <EyeSlashIcon className="h-5 w-5" aria-hidden="true"/>
                            : <EyeIcon className="h-5 w-5" aria-hidden="true"/>}
                    </button>
                </div>
            </div>

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}